import css from 'styled-jsx/css';

const styles = css`:root {
    /* @TODO get a hold of/unify these colors...
       tell design to stop giving us a new color palatte
       with each new design...
    */

    /* New II Design Pattern - Introduced 11-12-2019 */
    /* TODO: --grey-800 is the color for primary text and should be used throughout the entire application */
}
:root {

    /* Margin and padding should be in multiples of 8 (i.e.---8, 16, 24) */

    /* New II Design Pattern - Introduced 11-12-2019 */
}
:root {

    /* New II Design Pattern - Introduced 11-12-2019 */
}
/* @import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css'; */
/* Shared Styles */
.popup-content {
    border-radius: 8px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
    background-color: #ffffff;
    padding-top: 50px;
    color: #475359;
}
.close-btn {
    float: right;
    margin: 0;
    outline: 0;
    border: 0;
    background: none;
    padding: 0;
    font-family: inherit;
    font-style: inherit;
    cursor: pointer;
}
.subtitle {
    font-size: 16px;
    font-family: 'Nimbus Sans Light', sans-serif;
}
a {
    color: #086ea1;
    text-decoration: none;
}
a:hover {
    color: #004466;
    font-weight: bold;
}
/* Interstitial Modal */
.modal {
    padding: 11px;
    font-family: 'Nimbus Sans', sans-serif;
    line-height: 22px;
}
.centered-content {
    text-align: center;
    padding: 32px 0px;
}
.centered-content-2 {
    text-align: center;
    padding-top: 32px;
    padding-bottom: calc(8px * 2);
}
.funds-modal-title {
    font-size: 24px;
    line-height: 32px;
    text-align: center;
}
.check-mark {
    width: 52px;
    height: 52px;
    vertical-align: top;
    text-align: center;
}
.fund-info {
    margin-top: calc(8px * 2);
    margin-bottom: 12px;
    padding: 0 calc(8px * 2);
}
.fund-name {
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    text-align: center;
    padding-bottom: calc(8px * 2);
}
.fund-name:last-of-type {
    padding-bottom: 0;
}
.fund-ticker {
    font-weight: bold;
}
.closed {
    color: #929ba3;
}
.title {
    font-size: 24px;
    font-style: normal;
    font-family: 'Nimbus Sans Light', sans-serif;
}
.proceed {
    text-align: center;
    vertical-align: top;
    font-size: 16px;
}
.confirm-fund {
    color: #ffffff;
    background-color: #086ea1;
    padding: 13px 42px;
    border-radius: 4px;
    margin-top: 12px;
    margin-bottom: 30px;
    border: none;
    font-weight: bold;
}
.confirm-fund:disabled {
    background-color: #f7f7f7;
    color: #bbbbbb;
}
.login {
    padding: 0px 25px;
}
.login-underline {
    color: #086ea1;
}
/* Account Type Modal */
.modal2 {
    padding: 8px;
    font-family: 'Nimbus Sans', sans-serif;
}
.title2 {
    font-size: 24px;
    line-height: 32px;
    font-weight: bold;
}
hr {
    border-color: #eeeeee;
    border-top: 0px;
    border-left: 0px;
    width: 357px;
    position: relative;
    right: 13px;
}
.category-title {
    font-size: 16px;
    line-height: 26px;
    padding-top: calc(8px * 3);
    padding-bottom: calc(8px * 2);
    font-weight: bold;
}
.account-types a {
    font-size: 16px;
    display: block;
    padding-bottom: calc(8px * 2);
}
.see-all {
    font-size: 16px;
    padding: calc(8px * 2) 0;
    text-align: center;
}
.summit-notice {
    background: #eeeeee;
    padding: calc(8px * 2);
    font-size: 16px;
    color: #3b4b59;
    flex: none;
    order: 0;
    align-self: stretch;
    flex-grow: 0;
    margin-top: 0;
    margin-left: 0;
    margin-right: 0;
    margin-bottom: calc(8px * 2);
    text-align: left;
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg width='17' height='23' viewBox='0 0 17 23' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8.66854 14.0751C8.69745 14.0742 8.72064 14.0491 8.72064 14.0183C8.72064 13.987 8.69665 13.9616 8.66704 13.9616C8.63744 13.9616 8.61344 13.987 8.61344 14.0183C8.61344 14.0492 8.63665 14.0742 8.66556 14.0751L8.66702 14.0751L8.66854 14.0751Z' fill='%233B4B59'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M3.14611 8.17263V5.8457C3.14611 2.61721 5.61791 0 8.66704 0C11.7162 0 14.188 2.61721 14.188 5.8457V8.17263H14.6704C15.8249 8.17263 16.7608 9.16361 16.7608 10.386V20.3748C16.7608 21.5973 15.8249 22.5882 14.6704 22.5882H2.66369C1.50917 22.5882 0.573242 21.5973 0.573242 20.3748V10.386C0.573242 9.16361 1.50917 8.17263 2.66369 8.17263H3.14611ZM4.75415 5.8457C4.75415 3.55755 6.50601 1.70263 8.66704 1.70263C10.8281 1.70263 12.5799 3.55755 12.5799 5.8457V8.17263H4.75415V5.8457ZM8.66704 12.2589C7.74934 12.2589 7.0054 13.0466 7.0054 14.0183C7.0054 14.6812 7.35161 15.2584 7.863 15.5584V17.6506C7.863 18.1208 8.22297 18.5019 8.66702 18.5019C9.11107 18.5019 9.47104 18.1208 9.47104 17.6506V15.5584C9.98246 15.2585 10.3287 14.6812 10.3287 14.0183C10.3287 13.0466 9.58474 12.2589 8.66704 12.2589Z' fill='%233B4B59'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: 16px 20px;
    padding-left: 48px;
}
.summit-notice.unlocked {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg width='17' height='22' viewBox='0 0 17 22' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M13.1811 8.76294C13.7214 7.83557 13.9205 6.74849 13.7439 5.68983C13.5674 4.63116 13.0263 3.66753 12.2143 2.9657C11.4022 2.26387 10.3704 1.86802 9.29736 1.84662C8.22429 1.82522 7.17749 2.17962 6.33813 2.84852' stroke='%23054C70' stroke-width='2.22222' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M1.8877 10.4332C1.8877 9.77867 2.41832 9.24805 3.07288 9.24805H14.9239C15.5784 9.24805 16.109 9.77867 16.109 10.4332V19.7746C16.109 20.4291 15.5784 20.9598 14.9239 20.9598H3.07288C2.41832 20.9598 1.8877 20.4291 1.8877 19.7746V10.4332Z' fill='%23054C70' stroke='%23054C70' stroke-width='1.77778' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M8.9989 14.6855C9.46092 14.6855 9.83545 14.3109 9.83545 13.8489C9.83545 13.3869 9.46092 13.0124 8.9989 13.0124C8.53689 13.0124 8.16235 13.3869 8.16235 13.8489C8.16235 14.3109 8.53689 14.6855 8.9989 14.6855Z' fill='%23054C70' stroke='%23F2F8F4' stroke-width='2.66667' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M8.99829 14.6855V17.1952V14.6855Z' fill='%23054C70'/%3E%3Cpath d='M8.99829 14.6855V17.1952' stroke='%23F2F8F4' stroke-width='2.66667' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
    margin-top: calc(8px * 2);
    margin-left: calc(8px * 4);
    margin-right: calc(8px * 4);
}
`;

export default styles;